import styled from '@emotion/styled';
import fontSizes from '../../theme/foundations/fontSizes';
import screenSize from '../../constants/screen-sizes';
import Colors, { ThemeColors, Darkness } from '../../theme/foundations/colors';
import type { TextProps } from './Props';

function getColor(color: Colors, darkness: Darkness) {
  const c = ThemeColors[color] ? ThemeColors[color] : ThemeColors.black;
  const d = c[darkness] ? c[darkness] : c['500'];
  return d;
}

export const StyledHead = styled.h1<TextProps>`
    font-family: 'Poppins';
    font-weight: ${(props) => (props.weight ? props.weight : 600)};
    font-size: ${(props) =>
      props.size ? fontSizes[props.size] : fontSizes['3xl']} !important;
    color: ${(props) =>
      getColor(props.color || 'black', props.darkness || '500')};
    @media screen and (max-width: ${screenSize.IPAD}) {
        font-size: ${(props) =>
          props.mobilesize
            ? fontSizes[props.mobilesize]
            : fontSizes['xl']} !important;
    }
`;

export const StyledHead2 = styled.h2<TextProps>`
    font-family: 'Poppins';
    font-weight: ${(props) => (props.weight ? props.weight : 600)};
    font-size: ${(props) =>
      props.size ? fontSizes[props.size] : fontSizes['xl']} !important;
    color: ${(props) =>
      getColor(props.color || 'black', props.darkness || '500')};
    @media screen and (max-width: ${screenSize.IPAD}) {
        font-size: ${(props) =>
          props.mobilesize
            ? fontSizes[props.mobilesize]
            : fontSizes['lg']} !important;
    }
`;

export const StyledHead3 = styled.h3<TextProps>`
    font-family: 'Poppins';
    font-weight: ${(props) => (props.weight ? props.weight : 600)};
    font-size: ${(props) =>
      props.size ? fontSizes[props.size] : fontSizes['lg']} !important;
    color: ${(props) =>
      getColor(props.color || 'black', props.darkness || '500')};
    @media screen and (max-width: ${screenSize.IPAD}) {
        font-size: ${(props) =>
          props.mobilesize
            ? fontSizes[props.mobilesize]
            : fontSizes['md']} !important;
    }
`;

export const StyledHead4 = styled.h4<TextProps>`
    font-family: 'Poppins';
    font-weight: ${(props) => (props.weight ? props.weight : 600)};
    font-size: ${(props) =>
      props.size ? fontSizes[props.size] : fontSizes['md']} !important;
    color: ${(props) =>
      getColor(props.color || 'black', props.darkness || '500')};
    @media screen and (max-width: ${screenSize.IPAD}) {
        font-size: ${(props) =>
          props.mobilesize
            ? fontSizes[props.mobilesize]
            : fontSizes['sm']} !important;
    }

    a {
      text-decoration: underline;
    }
`;

export const StyledBody = styled.p<TextProps>`
    text-align: ${(props) => props.textAlign || 'left'};
    font-family: 'Poppins';
    font-weight: ${(props) => (props.weight ? props.weight : 400)};
    line-height: 1.5;
    font-size: ${(props) =>
      props.size ? fontSizes[props.size] : fontSizes['md']} !important;
    color: ${(props) =>
      getColor(props.color || 'black', props.darkness || '500')};
    strong, b {
        font-weight: ${(props) =>
          props.strongWeight ? props.strongWeight : 500};
    }

    @media screen and (max-width: ${screenSize.IPAD}) {
        font-size: ${(props) =>
          props.mobilesize
            ? fontSizes[props.mobilesize]
            : fontSizes['md']} !important;
    }

    a {
      text-decoration: underline;
    }
`;

export const StyledCardBody = styled.p<TextProps>`
    text-align: ${(props) => props.textAlign || 'left'};
    font-family: 'Poppins';
    font-weight: ${(props) => (props.weight ? props.weight : 400)};
    font-size: ${(props) =>
      props.size ? fontSizes[props.size] : fontSizes['md']} !important;
    color: ${(props) =>
      getColor(props.color || 'black', props.darkness || '500')};
    strong, b {
        font-weight: ${(props) =>
          props.strongWeight ? props.strongWeight : 500};
    }

    @media screen and (max-width: ${screenSize.IPAD}) {
        font-size: ${(props) =>
          props.mobilesize
            ? fontSizes[props.mobilesize]
            : fontSizes['md']} !important;
    }

    a {
      text-decoration: underline;
    }
`;
